import {
	HomeDemo1Partners1,
	HomeDemo1Partners2,
	HomeDemo1Partners3,
	HomeDemo1Partners4,
	HomeDemo1Partners5,
	HomeDemo1Partners6,
	HomeDemo1Icons1,
	HomeDemo1Icons2,
	HomeDemo1Icons3,
	HomeDemo1TeamImg1,
	HomeDemo1TeamImg2,
	HomeDemo1TeamImg3,
	HomeDemo1TeamImg4,

} from '../../../utils/allImgs'

export const SecPartnersContent = [
    
    {
        img:HomeDemo1Partners2,
    },    
    {
        img:HomeDemo1Partners1,
    },
    {
        img:HomeDemo1Partners3,
    },
    {
        img:HomeDemo1Partners4,
    },
    {
        img:HomeDemo1Partners5,
    },
    {
        img:HomeDemo1Partners6
    }
]

export const HowToStartInfo = [
    {
        img:HomeDemo1Icons1,
        num:1,
        title:"AI-Powered Trade Execution",
        text:"Leverage advanced AI algorithms to optimize your trading strategies and execution."
    },
    {
        img:HomeDemo1Icons2,
        num:2,
        title:"Seamless Liquidity Provision",
        text:"Benefit from AI-enhanced liquidity pools ensuring minimal slippage and optimal pricing."
    },
    {
        img:HomeDemo1Icons3,
        num:3,
        title:"Real-Time Market Insights",
        text:"Access AI curated analytics for informed decision-making and market forecasting."
    }
]

export const OurTeamInfo = [
    {
        img:HomeDemo1TeamImg1,
        title:"Joman Helal",
        text:"Executive Officer"
    },
    {
        img:HomeDemo1TeamImg2,
        title:"Slans Alons",
        text:"Business Development"
    },
    {
        img:HomeDemo1TeamImg3,
        title:"Josha Michal",
        text:"UX/UI Designer"
    },
    {
        img:HomeDemo1TeamImg4,
        title:"Johan Wright",
        text:"Head of Marketing"
    }
]